import { SchemeBase } from '../../../checkout/cart/scheme.class';

/**
 * Created by fruysshaert on 05/04/2017.
 */
import { SubscriptionBase } from '../subscription';

export class EdpBase extends SubscriptionBase {
    /**
     * Add EDP flag
     * @param scheme
     * @returns
     */
    public updateSchemeOnAdd(scheme: SchemeBase): SchemeBase {
        scheme.productContext.edp = true;
        scheme.updateContext(scheme.productContext);
        return scheme;
    }

    /**
     * remove EDP flag
     * @param scheme
     * @returns
     */
    public updateSchemeOnRemove(scheme: SchemeBase): SchemeBase {
        scheme.productContext.edp = false;
        scheme.updateContext(scheme.productContext);
        return scheme;
    }

    /**
     * to update the prices of EDP
     */
    protected updatePrice(): void {
        // @TODO: Uncomment once fixed
        this.price = this.context.edpData ? this.context.edpData.amount : 0;
        this.duration = this.context.edpData ? this.context.edpData.duration : 0;
    }
}
